import axios from "../../lib/axiosInstance";

export const fetchTalentPool = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);

  if (payload.search?.trim()) queryParams.append("search", payload.search.trim());

  const response = await axios.get(`talentPool?${queryParams.toString()}`);
  return response.data;
};

export const fetchUserTalentPools = (userId) =>
  axios.get(`talentPool/user/${userId}`).then((res) => res.data);

export function createTalentPool(payload) {
  return axios.post("talentPool", payload).then((res) => res.data);
}

export function updateTalentPool({ id, payload = {} }) {
  return axios.patch(`talentPool/${id}`, { name: payload }).then((res) => res.data);
}

export function deleteTalentPool(id) {
  return axios.delete(`talentPool/${id}`).then((res) => res.data);
}

export function addEngineerToTalentPool(payload) {
  return axios.post("talentPool/addUsersToTalentPool", payload).then((res) => res.data);
}

export function removeEngineerFromTalentPool(payload) {
  return axios.post("talentPool/removeUserFromTalentPool", payload).then((res) => res.data);
}
